import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["suggestion", "rejectButton"];
  static values = { originalValue: String, discardWarning: String };

  approve(event) {
    const button = event.currentTarget;
    const togglingOff = button.classList.contains("active");

    if (togglingOff) {
      if (this.hasSuggestionTarget) this.suggestionTarget.disabled = false;
      this.stimulate("AsbestosReportReviewReflex#update_annotation_status", button);
      return;
    }

    if (this.hasSuggestionTarget && this.suggestionChanged()) {
      if (this.hasDiscardWarningValue && this.discardWarningValue && !window.confirm(this.discardWarningValue)) {
        return;
      }
      this.suggestionTarget.value = this.originalValueValue;
    }

    if (this.hasSuggestionTarget) this.suggestionTarget.disabled = true;
    this.stimulate("AsbestosReportReviewReflex#update_annotation_status", button);
  }

  reject(event) {
    if (this.hasSuggestionTarget) this.suggestionTarget.disabled = false;
    this.stimulate("AsbestosReportReviewReflex#update_annotation_status", event.currentTarget);
  }

  markRejectedIfChanged() {
    if (!this.hasSuggestionTarget || !this.hasRejectButtonTarget) return;
    if (!this.suggestionChanged()) return;
    if (this.rejectButtonTarget.classList.contains("active")) return;

    this.stimulate("AsbestosReportReviewReflex#mark_rejected", this.rejectButtonTarget);
  }

  suggestionChanged() {
    return this.suggestionTarget.value.trim() !== this.originalValueValue.trim();
  }
}
